'use client'

import { Button, type ButtonProps } from '../../buttons/button.tsx'

export const ConfirmationModalButton = (props: ButtonProps) => {
  return <Button {...props} />
}
